/** @format */

export const CloseLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25.3337 8.54669L23.4537 6.66669L16.0003 14.12L8.54699 6.66669L6.66699 8.54669L14.1203 16L6.66699 23.4534L8.54699 25.3334L16.0003 17.88L23.4537 25.3334L25.3337 23.4534L17.8803 16L25.3337 8.54669Z"
                fill={color}
            />
        </svg>
    );
};
